import { Grid } from "@mui/material";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useCallback, useRef, useState } from "react";
import { taskAllocate } from "services/data.outbound.service";
import { getTaskAssignmentList } from "services/data.outbound.service";
import { Success, Error, LoadingDialog } from "ui-components/Alert";
import { CustomDatePicker } from "ui-components/CustomInput";
import { ReadonlyText } from "ui-components/Form";
import { Fieldset } from "ui-components/Form";
import { SelectFields } from "ui-components/Form";
import { TableCard } from "ui-components/Layout";
import CheckboxTable2 from "ui-components/tables/CheckboxTable2";
function Assign({
  columns,
  customerCode,
  userOptions,
  szOptions,
  categoryOptions,
  salesOptions,
  ptOptions,
  list,
  setList,
  setAlert,
}) {
  const queryClient = useQueryClient();
  const [pickers, setPickers] = useState(null);
  const [selectedIds, setSelectedIds] = useState([]);
  const [taskRequest, setTaskRequest] = useState({
    //status: "Open",
    shippingZone: null,
    category: [],
    orderType: null,
    sales: null,
    sku: null,
    qty: null,
    orderDate: null,
    orderTime: null
  });
  const [pickMethod, setPickMethod] = useState("Discrete Pick");
  const onError = (data) => setAlert(<Error data={data} onChange={setAlert} />);
  const [customRowSelection, setCustomRowSelection] = useState({});
  const [dateFrom, setDateFrom] = useState(null);
  const [group, setGroup] = useState("");

  const { isFetching, refetch } = useQuery({
    queryKey: ["task-list", { customerCode, taskRequest, dateFrom }],
    queryFn: () =>
      getTaskAssignmentList({
        customerCode,
        //status: taskRequest.status,
        shippingZone: taskRequest.shippingZone ?? "",
        category: taskRequest.category.join(","),
        //category: taskRequest.category ?? "",
        orderType: taskRequest.orderType ?? "",
        sales: taskRequest.sales ?? "",
        sku: taskRequest.sku ?? 0,
        qty: taskRequest.qty ?? 0,
        priority: taskRequest.priority ?? "",
        engraving: taskRequest.engraving ?? "",
        orderDate: dateFrom ?? "",
        orderTime: taskRequest.orderTime ?? "",
      }),
    refetchInterval: 90000,
    enabled: Boolean(customerCode),
    onSuccess: (data) => {
      const data_ = data.data.data.map((x) => {
        if (x.status === "O") {
          x["bgColor"] = "lightCyan";
        } else {
          x["bgColor"] = "bisque";
        }
        x.group = x.group.toString();
        return x;
      });
      setList(data_);
    },
    onError,
  });

  const onFetchList = () => {
    if (customerCode === null) return;
    refetch();
  };
  const onButtonSelect = (row) => {
    if (Number.isNaN(row)) {
      row = 0;
    }
    const listCount = list.filter((x) => x.status === "O").length;
    let selectCount = listCount > row ? row : listCount;
    // const array = [...Array(selectCount)].map((_) => true);
    // const custom = Object.assign({}, array);
    let selection = {};
    list
      .filter((x) => x.status === "O" && (group === "" || x.group === group))
      .slice(0, selectCount)
      .map((x) => x.id)
      .forEach((x) => {
        selection[x] = true;
      });
    setCustomRowSelection(selection);
    //setSelectedIds(listSliced);
  };

  const isSubmittingRef = useRef(false);
  const assignMutation = useMutation(taskAllocate, {
    onSuccess: (data) => {
      queryClient.invalidateQueries(["task-list"]);
      setAlert(<Success data={data} onChange={setAlert} />);
    },
    onError,
    onSettled: () => {
      isSubmittingRef.current = false;
    },
  });
  const onAssign = () => {
    if (isSubmittingRef.current) return;
    if (selectedIds.length === 0) return;
    if (customerCode === null) return;
    if ((pickMethod === "Batch Pick" || pickMethod === "Batch Pack" || pickMethod === "Cluster Pick") && !Boolean(pickers)) return;
    if (pickMethod === "Cluster Pick" && selectedIds.length > 50){
      setAlert(<Error content="Cluster Pick cannot assign more than 50 order" onChange={setAlert} />)
      return
    }
    //if (pickers.length > selectedIds.length) return;
    isSubmittingRef.current = true;
    const orderIdList = selectedIds.map((x) => x.id);
    const orderNumberList = selectedIds.map((x) => x.orderNumber);
    assignMutation.mutate({
      orderIdList,
      orderNumberList,
      status: taskRequest.status,
      customerCode,
      pickMethod,
      RFUserId: pickers ?? "",
    });
  };

  const handleChange = useCallback((data) => {
    setSelectedIds(data);
  }, []);

  const assignStatus = assignMutation.status === "loading";

  const date = new Date();

  return (
    <>
      {(isFetching || assignStatus) && <LoadingDialog />}
      <TableCard sx={{ margin: "2rem 0", padding: 2 }}>
        {/* <Grid container spacing={3}>
          <Grid item xs={3}>
            <ReadonlyText
              field={{
                label: "Last Preallocate",
                name: "lastPreallocate",
                value: lastPreallocate,
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <ReadonlyText
              field={{
                label: "Customer Code",
                name: "customerCode",
                value: customerCode,
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <MDButton
              color="info"
              variant="gradient"
              onClick={onPreallocate}
              //disabled={list.length === 0}
            >
              Preallocate
            </MDButton>
          </Grid>
        </Grid> */}
        <Fieldset label="Filter" sx={{ marginBottom: "1.5rem" }}>
          <Grid container spacing={3}>
            {/* <Grid item xs={2}>
              <SelectFields
                field={{
                  name: "",
                  label: "Order Status",
                  value: taskRequest.status,
                  required: true,
                  errors: {},
                }}
                options={["Open", "Not Enough Stock"]}
                onChange={(e, value) => setTaskRequest({ ...taskRequest, status: value ?? "" })}
              />
            </Grid> */}
            <Grid item xs={2}>
              <SelectFields
                field={{
                  name: "",
                  label: "Shipping Zone",
                  value: taskRequest.shippingZone,
                  errors: {},
                }}
                options={szOptions}
                onChange={(e, value) =>
                  setTaskRequest({ ...taskRequest, shippingZone: value ?? "" })
                }
              />
            </Grid>
            <Grid item xs={2}>
              <SelectFields
                field={{ name: "", label: "Order Type", value: taskRequest.orderType, errors: {} }}
                options={["B2C", "B2B"]}
                onChange={(e, value) => {
                  setTaskRequest({ ...taskRequest, orderType: value ?? "" });
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <SelectFields
                field={{ name: "", label: "Marketplace", value: taskRequest.sales, errors: {} }}
                options={salesOptions}
                onChange={(e, value) => {
                  setTaskRequest({ ...taskRequest, sales: value ?? "" });
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <SelectFields
                field={{ name: "", label: "SKU", value: taskRequest.sku, errors: {} }}
                options={[...Array(25)].map((x, index) => `${index + 1}`)}
                onChange={(e, value) => {
                  setTaskRequest({ ...taskRequest, sku: value });
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <SelectFields
                field={{ name: "", label: "Qty", value: taskRequest.qty, errors: {} }}
                options={[...Array(25)].map((x, index) => `${index + 1}`)}
                onChange={(e, value) => {
                  setTaskRequest({ ...taskRequest, qty: value });
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <SelectFields
                field={{ name: "", label: "Priority", value: taskRequest.priority, errors: {} }}
                options={ptOptions}
                onChange={(e, value) => {
                  setTaskRequest({ ...taskRequest, priority: value });
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <SelectFields
                field={{ name: "", label: "Engraving", value: taskRequest.engraving, errors: {} }}
                options={["Engraving"]}
                onChange={(e, value) => {
                  setTaskRequest({ ...taskRequest, engraving: value });
                }}
              />
            </Grid>
            <Grid item xs={2}>
              <CustomDatePicker
                field={{
                  name: "startDate",
                  label: "Order Date",
                  value: dateFrom,
                  onChange: setDateFrom,
                }}
              />
            </Grid>
            {console.log(dateFrom)}
            <Grid item xs={2}>
              <SelectFields
                field={{ name: "", label: "Order Time", value: taskRequest.orderTime, errors: {}, disabled: dateFrom === null }}
                options={[...Array(24)].map((x, index) => {
                  if(index < 10) return `0${index}:00:00`
                  return `${index}:00:00`;
                })}
                onChange={(e, value) => {
                  setTaskRequest({ ...taskRequest, orderTime: value });
                }}
              />
            </Grid>
            <Grid item xs={4}>
              <SelectFields
                field={{
                  name: "",
                  label: "SKU Category",
                  value: taskRequest.category,
                  errors: {},
                  multiple: true,
                }}
                options={categoryOptions}
                onChange={(e, value) => {
                  setTaskRequest({ ...taskRequest, category: value ?? "" });
                }}
              />
            </Grid>
            <Grid item>
              <MDButton color="info" variant="gradient" onClick={() => onFetchList()}>
                Retrieve
              </MDButton>
            </Grid>
          </Grid>
        </Fieldset>

        <Grid container spacing={3}>
          <Grid item xs={3}>
            <SelectFields
              field={{ name: "", label: "Pick Method", value: pickMethod, errors: {} }}
              //options={["Discrete Pick", "Batch Pick", "Cluster Pick", "Wave Pick"]}
              //options={["Discrete Pick", "Batch Pick", "Wave Pick"]}
              //options={["Discrete Pick"]}
              options={
                customerCode === "VN-SYNAGIE" || customerCode === "PH-SYNAGIE"
                  ? ["Discrete Pick","Cluster Pick", "Batch Pick", "Wave Pick"]
                  : ["Discrete Pick","Cluster Pick", "Batch Pick", "Wave Pick", "TSorter", "AirRob", "Batch Pack"]
              }
              onChange={(e, v) => {
                if (v === "Wave Pick") {
                  setPickers(null);
                }
                setPickMethod(v);
              }}
            />
          </Grid>
          <Grid item xs={3}>
            <SelectFields
              field={{
                name: "",
                label: "Picker",
                value: pickers,
                errors: {},
                disabled: pickMethod === "Wave Pick",
                //multiple: true,
              }}
              options={userOptions}
              onChange={(e, v) => setPickers(v)}
            />
          </Grid>
          <Grid item>
            <MDButton
              color="info"
              variant="gradient"
              onClick={() => onAssign("SINGLE")}
              disabled={
                assignStatus || selectedIds.length === 0 || ((pickMethod === "Batch Pick" || pickMethod === "Batch Pack" || pickMethod === "Cluster Pick") && !Boolean(pickers))
              }
            >
              Assign
            </MDButton>
          </Grid>
        </Grid>
      </TableCard>

      <TableCard>
        <Grid sx={{ margin: "-12px 0 0 -12px" }} container spacing={3}>
          <Grid item xs={1}>
            <SelectFields
              field={{ name: "", label: "Select", errors: {} }}
              options={pickMethod === "Cluster Pick" ? ["6", "8", "10", "20", "30", "40", "50"] : ["10", "20", "40", "60", "100", "150", "200", "300"]}
              onChange={(e, v) => onButtonSelect(parseInt(v))}
            />
          </Grid>
          <Grid item xs={1}>
            <ReadonlyText
              field={{
                label: "Selected Count",
                name: "selectedCount",
                value: selectedIds.length,
              }}
            />
          </Grid>
          <Grid item xs={2}>
            <ReadonlyText
              field={{
                label: "Last Updated",
                name: "lastUpdated",
                value: date.toLocaleString(),
              }}
            />
          </Grid>
          <Grid item xs={7}>
            <MDBox sx={{ padding: "8px 0" }} display="flex" alignItems="center">
              <MDTypography color="info" variant="h5" mr="1rem">
                Row Status :
              </MDTypography>
              <span
                style={{
                  width: "1rem",
                  height: "1rem",
                  border: "1px solid black",
                  background: "#bdf9f9",
                }}
              ></span>
              <MDTypography ml={1} variant="h6" mr="2rem">
                Open
              </MDTypography>
              <span
                style={{
                  width: "1rem",
                  height: "1rem",
                  border: "1px solid black",
                  background: "bisque",
                }}
              ></span>
              <MDTypography ml={1} variant="h6" mr="2rem">
                NotEnoughStock
              </MDTypography>
              <span
                style={{
                  width: "1rem",
                  height: "1rem",
                  border: "1px solid black",
                  background: "lightpink",
                }}
              ></span>
              <MDTypography ml={1} variant="h6" mr="2rem">
                Selected
              </MDTypography>
            </MDBox>
          </Grid>
        </Grid>

        <CheckboxTable2
          data={list}
          columns={columns}
          customRowSelection={customRowSelection}
          setCustomRowSelection={setCustomRowSelection}
          onSelectedRowsChange={handleChange}
          customColor={true}
          customFilter={(name, v) => {
            if (name === "group") {
              setGroup(v);
            }
          }}
        />
      </TableCard>
    </>
  );
}

export default Assign;
